/** Canonical portal / award tiers. Registration may still persist Global as `accredited`. */
export const ACCREDITATION_LEVELS = ['foundation', 'certified', 'global'];

const RANK = {
  foundation: 0,
  certified: 1,
  global: 2,
};

const SHORT_LABEL = {
  foundation: 'Foundation',
  certified: 'Certified',
  global: 'Global',
};

const LONG_LABEL = {
  foundation: 'Foundation',
  certified: 'Certified',
  global: 'Global Accreditation',
};

const REPORT_TITLE = {
  foundation: 'IFIP Foundation Inclusive School',
  certified: 'IFIP Certified Inclusive School',
  global: 'IFIP Global Accreditation',
};

export function normalizeAccreditationLevel(raw) {
  const key = String(raw || 'foundation').trim().toLowerCase();
  if (key === 'accredited' || key === 'global') return 'global';
  if (key === 'certified') return 'certified';
  if (key === 'foundation') return 'foundation';
  return 'foundation';
}

export function isValidAccreditationLevel(raw) {
  const key = String(raw || '').trim().toLowerCase();
  return ACCREDITATION_LEVELS.includes(key);
}

export function accreditationLevelRank(raw) {
  return RANK[normalizeAccreditationLevel(raw)] ?? 0;
}

export function accreditationLevelLabel(raw, { long = false } = {}) {
  const key = normalizeAccreditationLevel(raw);
  return long ? LONG_LABEL[key] : SHORT_LABEL[key];
}

export function accreditationLevelReportTitle(raw) {
  return REPORT_TITLE[normalizeAccreditationLevel(raw)];
}

/**
 * Compare awarded/target (`current`) to signed-up / requested (`registered`).
 * @returns {'match' | 'up' | 'down'}
 */
export function compareAccreditationLevels(current, registered) {
  const currentRank = accreditationLevelRank(current);
  const registeredRank = accreditationLevelRank(registered);
  if (currentRank === registeredRank) return 'match';
  return currentRank > registeredRank ? 'up' : 'down';
}

export function resolveLiveAccreditationLevel(school) {
  return normalizeAccreditationLevel(school?.accreditationLevel);
}

/** Original signup / requested tier. Falls back to live level when the snapshot was never stored. */
export function resolveRegisteredAccreditationLevel(school) {
  return normalizeAccreditationLevel(
    school?.registeredAccreditationLevel ||
      school?.appliedOffer?.appliedLevel ||
      school?.accreditationLevel ||
      'foundation'
  );
}

/** Prefer the cycle snapshot (archive or live report), then the school doc. */
export function resolveCycleAccreditationLevel(reportOrArchive, school) {
  return normalizeAccreditationLevel(
    reportOrArchive?.accreditationLevel ||
      reportOrArchive?.meta?.accreditationLevel ||
      school?.accreditationLevel ||
      'foundation'
  );
}
